import {useQuery} from '@tanstack/react-query'
import {useServices} from '@/services/context'
import type {Palette} from '@/types/form-layout'

/**
 * TanStack Query hook for fetching the palette for a specific use-case.
 * Exposes refetch for error-state retry.
 */
export function useFormLayoutPalette(useCaseKey: string) {
    const services = useServices()
    const query = useQuery<Palette>({
        queryKey: ['form-layouts', 'palette', useCaseKey],
        queryFn: () => services.formLayouts.palette(useCaseKey),
        retry: 1,
    })

    return {
        palette: query.data ?? null,
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: query.refetch,
    }
}
